import { makeStyles } from 'tss-react/mui';

export default makeStyles()({
    container: {
        padding: 16,
        border: '1px solid #E0E0E0',
        borderRadius: 18,
        boxSizing: 'border-box'
    },
    headerCell: {
        fontWeight: 'bold'
    },
    spinner: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px 0'
    },
    pagination__root: {
        borderBottom: 'none',
        borderTop: '1px solid rgba(224, 224, 224, 1)'
    },
    pagination__toolbar: {
        paddingTop: 16,
        paddingLeft: 0,
        paddingRight: 0,
        overflow: 'hidden',
        minWidth: 'min-content'
    }
});
